import { cn } from '@/lib/utils'
import { spaceHueClass, type SpaceHue } from '@/lib/spaceHue'

/**
 * The small square that says which space something happens in, in the space's
 * content hue (see `spaceHues`).
 *
 * A transition — a flip between two arrangements — is a honey diamond instead,
 * wherever it appears, because what matters about a flip is that the room is
 * being turned, not which room it is; its name says that. Decorative: the
 * space's name is always written beside it.
 */
export function SpaceMark({
  hue,
  transition = false,
  className,
}: {
  /** Undefined for a space the venue no longer lists — the mark goes neutral. */
  hue: SpaceHue | undefined
  transition?: boolean
  className?: string
}) {
  return (
    <span
      aria-hidden
      className={cn(
        'ds-space-mark',
        transition ? 'ds-space-mark--transition' : hue !== undefined && spaceHueClass(hue),
        className,
      )}
    />
  )
}
